import { combineSlices } from '@reduxjs/toolkit';
import navigationSlice from '../components/theme-layouts/components/navigation/store/navigationSlice';
import navbarSlice from '../components/theme-layouts/components/navbar/navbarSlice';
import columnsSlice from './columnsSlice';
import assetsRegisterCountsSlice from './assetsRegisterCountsSlice';

const rootReducer = combineSlices({
	navigation: navigationSlice,
	navbar: navbarSlice,
	columns: columnsSlice,
	assetsRegisterCounts: assetsRegisterCountsSlice,
});

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface LazyLoadedSlices {}

export default rootReducer;
